export const SAVE_PARTS_ORDER_LOADING = 'SAVE_PARTS_ORDER_LOADING';
export const SAVE_PARTS_ORDER_ERROR = 'SAVE_PARTS_ORDER_ERROR';
export const SAVE_PARTS_ORDER_SUCCESS = 'SAVE_PARTS_ORDER_SUCCESS';
export const SAVE_PARTS_ORDER_RESET = 'SAVE_PARTS_ORDER_RESET';
